import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "@phosphor-icons/react";
import { api, act, useFetch, fmtDate } from "@/lib/api";
import { PageHeader, Badge, Field, Empty } from "@/components/common";
import { Sel } from "@/components/Sel";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const STEPS = [
  { day: 0, subject: "{{company}} and client document chasing", body: "Hi {{first_name}},\n\n..." },
  { day: 3, subject: "Re: {{company}} and client document chasing", body: "Hi {{first_name}},\n\n..." },
];

export default function Campaigns() {
  const { data } = useFetch("/campaigns");
  const { data: products } = useFetch("/products");
  const { data: segments } = useFetch("/segments");
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", steps: STEPS });
  const nav = useNavigate();
  const create = async () => { const r = await act(() => api.post("/campaigns", f), "Draft campaign created"); if (r) nav(`/campaigns/${r.id}`); };
  return (
    <div data-testid="campaigns-page">
      <PageHeader eyebrow="S07–S10 · Campaigns & sequences" title="Sequences" desc="Agents draft from approved claims; launch is gated by charter, product approval, claim check and kill switch. A human reply always pauses the sequence.">
        <Button data-testid="create-campaign-btn" onClick={() => setOpen(true)} className="gap-1 bg-[#007AFF] hover:bg-[#3395FF]"><Plus /> Manual campaign</Button>
      </PageHeader>
      {!data?.length ? <Empty>No campaigns yet — run the AI Manager and the Content producer will draft one from your charter.</Empty> : (
        <div className="border border-border rounded-md overflow-x-auto">
          <table className="w-full text-sm" data-testid="campaigns-table">
            <thead className="bg-[#121212]"><tr className="text-left text-[11px] uppercase tracking-wider text-zinc-500 font-mono">
              {["Campaign", "Status", "Created by", "Steps", "Active", "Sent", "Blocked", "Replies", "Claim check"].map((h) => <th key={h} className="px-4 py-3 border-b border-border font-medium">{h}</th>)}
            </tr></thead>
            <tbody>{data.map((c) => (
              <tr key={c.id} data-testid={`campaign-row-${c.id}`} onClick={() => nav(`/campaigns/${c.id}`)} className="border-b border-border/60 hover:bg-[#151515] cursor-pointer transition-colors">
                <td className="px-4 py-3"><div className="font-medium">{c.name}</div><div className="text-xs text-zinc-500 font-mono">{fmtDate(c.created_at)}</div></td>
                <td className="px-4 py-3"><Badge v={c.status} /></td>
                <td className="px-4 py-3 text-xs">{c.created_by}</td>
                <td className="px-4 py-3 tnum">{c.steps?.length}</td>
                <td className="px-4 py-3 tnum">{c.stats.enrollments.active || 0}</td>
                <td className="px-4 py-3 tnum">{c.stats.sent}</td>
                <td className="px-4 py-3 tnum text-[#FF6961]">{c.stats.blocked}</td>
                <td className="px-4 py-3 tnum">{c.stats.replies}</td>
                <td className="px-4 py-3">{c.claim_check?.passed ? <Badge v="passed" tone="green" /> : <Badge v="failed" tone="red" />}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#121212] border-border">
          <DialogHeader><DialogTitle>New manual campaign</DialogTitle></DialogHeader>
          <Field label="Name"><Input data-testid="campaign-name-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="bg-black" /></Field>
          <Field label="Product"><Sel testid="campaign-product-select" value={f.product_id} onChange={(v) => setF({ ...f, product_id: v })} options={(products || []).map((p) => ({ value: p.id, label: p.name }))} /></Field>
          <Field label="Segment"><Sel testid="campaign-segment-select" value={f.segment_id} onChange={(v) => setF({ ...f, segment_id: v })} options={(segments || []).map((s) => ({ value: s.id, label: s.name }))} /></Field>
          <Button data-testid="campaign-create-submit" disabled={!f.name || !f.product_id || !f.segment_id} onClick={create} className="bg-[#007AFF] hover:bg-[#3395FF]">Create draft</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
